/**
 * @module components/Carousel
 * @description Embla Carousel wrapper component for image/content carousels.
 * Configured with auto-play and infinite loop for asset preview galleries.
 */

import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
// import { isDev } from "../modules/utils";

/**
 * @typedef Props
 * @property {Array<React.ReactNode>} children - Array of slide elements to display in carousel
 */

/**
 * @component EmblaCarousel
 * @summary React component wrapper for Embla Carousel plugin with autoplay.
 * Displays children as carousel slides with infinite loop and automatic progression.
 * @type {React.FC<Props>}
 * @param {Props} props - Component props
 * @returns {React.ReactElement} Carousel container with slides
 */
export const EmblaCarousel = (props) => {
  const [emblaRef] = useEmblaCarousel({ loop: true }, [
    Autoplay(),
  ]);

  // useEffect(() => {
  //   if (emblaApi && isDev()) {
  //     console.log(emblaApi.slideNodes()); // Access API
  //   }
  // }, [emblaApi]);
  return (
    <div className="embla" ref={emblaRef}>
      <div className="embla__container">
        {props.children.map((child) => (
          <div className="embla__slide">{child}</div>
        ))}
      </div>
    </div>
  );
};
